import dayjs from 'dayjs';
import CreateColumn from '../../../../Services/agGrid/createColumn';

export const getColumnDefs1 = (props) => [
  CreateColumn('no', 'NO', 'right', 80, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow: props.DeleteNewRow1,
      RestoreRow: props.RestoreRow1,
      gridRef: props.gridRef1,
      rowData: props.rowData1,
      selectedRowNosRef: props.selectedRowNosRef1,
      lastCheckedIndexRef: props.lastCheckedIndexRef1,
      handleRowSelection: props.handleRowSelection1,
    },
  }),
  CreateColumn('sessionCd', '세션코드', 'left', 200, false, false, true),
  CreateColumn('tbmTitle', '제목', 'left', 200, true),
  CreateColumn('tbmDate', '일자', 'center', 140, false, false, false, 'text', {
    valueFormatter: (params) => {
      if (!params.value) return '';
      return dayjs(params.value).format('YYYY-MM-DD');
    },
    cellClass: 'read-only-italic-cell',
    customCellStyle: {
      backgroundColor: '#f5f5f5',
      color: '#666',
      fontStyle: 'italic',
      cursor: 'not-allowed',
    },
  }),
  CreateColumn('startDt', '시작', 'center', 80, false, false, false, 'text', {
    valueFormatter: (params) => {
      if (!params.value) return '';
      return dayjs(params.value).format('HH:mm');
    },
    customCellStyle: {
      backgroundColor: '#f5f5f5',
      color: '#666',
      fontStyle: 'italic',
      cursor: 'not-allowed',
    },
  }),
  CreateColumn('endDt', '종료', 'center', 80, false, false, false, 'text', {
    valueFormatter: (params) => {
      if (!params.value) return '';
      return dayjs(params.value).format('HH:mm');
    },
    customCellStyle: {
      backgroundColor: '#f5f5f5',
      color: '#666',
      fontStyle: 'italic',
      cursor: 'not-allowed',
    },
  }),
  CreateColumn(
    'totalElapsedTime',
    '실시 시간(분)',
    'center',
    130,
    false,
    false,
    false,
    'text',
    {
      valueFormatter: (params) => {
        if (!params.data) return '0분';
        const seconds = Number(params.data.totalElapsedTime);
        if (isNaN(seconds) || seconds === 0) return '0분';
        const minutes = Math.floor(seconds / 60);
        if (minutes <= 0) return '0분';
        const hours = Math.floor(minutes / 60);
        const remainMin = minutes % 60;
        let result = '';
        if (hours > 0) result += `${hours}시간 `;
        if (remainMin > 0) result += `${remainMin}분`;
        return result.trim();
      },
      customCellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        textAlign: 'center',
        cursor: 'not-allowed',
      },
    }
  ),
  CreateColumn('tbmAddress', '장소', 'left', 180, true),
  CreateColumn(
    'userCnt',
    '참석인원',
    'center',
    110,
    false,
    false,
    false,
    'text',
    {
      customCellStyle: {
        backgroundColor: '#f5f5f5',
        color: '#666',
        fontStyle: 'italic',
        textAlign: 'center',
        cursor: 'not-allowed',
      },
    }
  ),
  CreateColumn('hostNm', '진행자', 'left', 120, false, false, false, 'text', {
    customCellStyle: {
      backgroundColor: '#f5f5f5',
      color: '#666',
      fontStyle: 'italic',
      cursor: 'not-allowed',
    },
  }),
  CreateColumn('entryPath', '회의사진', 'left', 100, true, false, true),
  CreateColumn(
    'meetPath',
    '회의내용',
    'center',
    110,
    false,
    false,
    false,
    'button',
    {
      buttonText: '내용 보기',
      buttonClickHandler: (params) => {
        props.PopupClickEvent1(params.data);
      },
      buttonSx: { width: '100%' },
    }
  ),
];

export const getColumnDefs2 = (props) => [
  CreateColumn('no', 'NO', 'right', 80, false, false, false, 'checkbox', {
    // checkboxProps: {
    //   DeleteNewRow: props.DeleteNewRow2,
    //   RestoreRow: props.RestoreRow2,
    //   gridRef: props.gridRef2,
    //   rowData: props.rowData2,
    //   selectedRowNosRef: props.selectedRowNosRef2,
    //   lastCheckedIndexRef: props.lastCheckedIndexRef2,
    //   handleRowSelection: props.handleRowSelection2,
    // },
    headerCheckboxSelection: true,
    checkboxSelection: true,
  }),
  CreateColumn('sessionCd', '세션코드', 'left', 200, false, false, true),
  CreateColumn('depNm1', '본부', 'left', 110, false, false, false),
  CreateColumn('depNm2', '부서', 'left', 110, false, false, false),
  CreateColumn('depNm3', '팀', 'left', 110, false, false, false),
  CreateColumn('depNm4', '파트', 'left', 110, false, false, false),
  CreateColumn('rank', '직위', 'left', 110, false, false, false),
  CreateColumn('userNm', '참석자명', 'left', 110, false, false, false, 'text', {
    flex: 1,
  }),
];

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
